import { render, staticRenderFns } from "./Characteristic.vue?vue&type=template&id=01578d3e&scoped=true&"
import script from "./Characteristic.vue?vue&type=script&lang=js&"
export * from "./Characteristic.vue?vue&type=script&lang=js&"
import style0 from "./Characteristic.vue?vue&type=style&index=0&id=01578d3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01578d3e",
  null
  
)

export default component.exports